import { IoMdClose } from "react-icons/io";

const ScopeMultiSelect = ({
  invoiceScope,
  selectedScope,
  setSelectedScope,
}) => {
  // Convert invoiceScope to proper options
  const options = invoiceScope.map((item) => ({
    label: item.scope_name,
    value: item.status_id,
    color: item.scope_color || "#ddd", // Default color if missing
  }));

  // Compute available scopes (Exclude already selected ones)
  const availableScopes = options.filter(
    (s) => !selectedScope.includes(s.value)
  );

  // Handle selection
  const handleSelect = (scopeId) => {
    const updatedScopes = [...selectedScope, scopeId];
    setSelectedScope(updatedScopes);
  };

  // Handle removal
  const handleRemove = (scopeId) => {
    const updatedScopes = selectedScope.filter((id) => id !== scopeId);
    setSelectedScope(updatedScopes);
  };

  return (
    <div
      className="inv-status-container"
      style={{ backgroundColor: "transparent" }}
    >
      {selectedScope.map((scopeId) => {
        const scopeObj = options.find((s) => s.value === scopeId);
        return (
          <div
            key={scopeId}
            className="invoice-selected-status-item selected"
            style={{
              backgroundColor: scopeObj?.color || "white",
            }}
          >
            {scopeObj?.label}
            <button
              onClick={() => handleRemove(scopeId)}
              style={{
                backgroundColor: "transparent",
                border: "none",
                marginLeft: "-5px",
                marginTop: "2px",
                cursor: "pointer",
              }}
            >
              <IoMdClose
                style={{
                  backgroundColor: "transparent",
                  color: "white",
                  fontSize: "12px",
                  cursor: "pointer",
                }}
              />
            </button>
          </div>
        );
      })}

      {/* Available Scopes */}
      <div className="available-scope-statuses-invoice">
        {availableScopes.map((scope) => (
          <div
            key={scope.value}
            className="invoice-status-item available"
            style={{
              backgroundColor: scope.color || "white",
            }}
          >
            <button
              onClick={() => handleSelect(scope.value)}
              style={{
                backgroundColor: "transparent",
                border: "none",
                fontFamily: "Lato, sans-serif",
                fontSize: "12px",
                cursor: "pointer",
              }}
            >
              {scope.label}
            </button>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ScopeMultiSelect;
